// import { unflatten } from 'flat';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col, FormGroup,
} from 'reactstrap';
import Select from 'react-select';
import { axios } from 'ApiClient';
import CheckboxFilter from '../../../../../shared/components/CheckboxFilter';
import {
  updateCreatorFilterItemUpdate,
  updateTopMenuCreatorLink,
} from '../../../../../redux/reducers/brand/CreatorsReducer';
import { countriesBH } from '../../../../../shared/helpers/WVConstants';

const Table = React.memo(({
  filters,
  dispatch,
  history,
}) => {
  const [search, setSearch] = useState('');
  const [dateSearch, setDateSearch] = useState(null);
  const [loadingProgramCountryOptions, setLoadingProgramCountryOptions] = useState(false);
  const [programCountryOptions, setProgramCountryOptions] = useState([]);

  const loadHubilCountriesOptions = async () => {
    setLoadingProgramCountryOptions(true);
    await axios.getSafety('/api/brand/dashboard/get-program-country-options').then((data) => {
      if (data.success === true && data.options?.length > 0) {
        const co = data.options.map(option => ({ value: option.value, label: option.label }));
        co.unshift({ value: null, label: '-- Not Assigned --' });
        setProgramCountryOptions(co);
      } else {
        setProgramCountryOptions([{ value: null, label: '-- Not Assigned --' }]);
        console.log('Program Country options are not available for this moment');
      }
    }).catch((err) => {
      console.log(err);
    });
    setLoadingProgramCountryOptions(false);
  };

  useEffect(() => {
    loadHubilCountriesOptions();
  }, []);

  const countryOpt = Object.entries(countriesBH()).map(entry => ({ value: entry[0], label: entry[1] }));
  countryOpt.unshift({ value: 'null', label: '-- Not Assigned --' });
  const selectedCountries = filters?.countryFilter?.map(f => f.value) || [];
  const selectedProgramCountries = filters?.programCountryFilter?.map(f => f.value) || [];

  useEffect(() => {
    if (dateSearch) {
      clearTimeout(dateSearch);
    }
    setDateSearch(setTimeout(() => {
      dispatch(updateCreatorFilterItemUpdate('search', search));
    }, 1000));
  }, [search]);

  const getUrlSearch = () => {
    const searchParams = new URLSearchParams(window.location.search);
    if (search) {
      searchParams.set('filters.fullSearchName', search);
    } else {
      searchParams.delete('filters.fullSearchName');
    }
    if (filters && filters.compliantFilter && Object.keys(filters.compliantFilter).length > 0) {
      searchParams.delete('filters.compliant');
      Object.keys(filters.compliantFilter).forEach((key) => {
        if (!filters.compliantFilter[key]) return false;
        searchParams.append('filters.compliant', key);
        return true;
      });
    }
    if (filters && filters.publishedFilter && Object.keys(filters.publishedFilter).length > 0) {
      searchParams.delete('filters.published');
      Object.keys(filters.publishedFilter).forEach((key) => {
        if (!filters.publishedFilter[key]) return false;
        searchParams.append('filters.published', key);
        return true;
      });
    }
    if (filters && filters.creatorType && Object.keys(filters.creatorType).length > 0) {
      searchParams.delete('filters.creatorType');
      Object.keys(filters.creatorType).forEach((key) => {
        if (!filters.creatorType[key]) return false;
        searchParams.append('filters.creatorType', key);
        return true;
      });
    }
    searchParams.delete('filters.country');
    if (filters && filters.countryFilter.length) {
      filters.countryFilter.forEach((key) => {
        searchParams.append('filters.country', key.value);
      });
    }
    searchParams.delete('filters.programCountry');
    if (filters && filters.programCountryFilter.length) {
      filters.programCountryFilter.forEach((key) => {
        searchParams.append('filters.programCountry', key.value);
      });
    }
    return searchParams;
  };

  const setUrl = (setFirstPage = false) => {
    const urlSearch = getUrlSearch();
    if (setFirstPage) {
      urlSearch.set('page', '1');
    }
    const strSearch = urlSearch.toString();
    dispatch(updateTopMenuCreatorLink(`/creators/list?${strSearch}`));
    history.push(`${history.location.pathname}?${strSearch}`);
  };

  useEffect(() => {
    setUrl(true);
  }, [filters]);

  const colourStyles = {
    multiValue: styles => ({
      ...styles,
      backgroundColor: '#70bbfd',
    }),
    multiValueLabel: styles => ({
      ...styles,
      color: 'white',
    }),
    multiValueRemove: styles => ({
      ...styles,
      color: 'white',
      ':hover': {
        backgroundColor: '#a2e1fd',
        color: '#70bbfd',
      },
    }),
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          <div className="float-left my-1" style={{ width: '3px' }} />
          <CheckboxFilter
            filterProp={filters.compliantFilter}
            filterTitle="Compliant"
            filterAction={({ data }) => dispatch(updateCreatorFilterItemUpdate('compliantFilter', data))}
          />
          <CheckboxFilter
            filterProp={filters.publishedFilter}
            filterTitle="Published"
            filterAction={({ data }) => dispatch(updateCreatorFilterItemUpdate('publishedFilter', data))}
          />
          <CheckboxFilter
            filterProp={filters.creatorType}
            filterTitle="Creator Type"
            filterAction={({ data }) => dispatch(updateCreatorFilterItemUpdate('creatorType', data))}
            customClass="not-exist-class"
          />
        </Col>
        <Col>
          <UncontrolledButtonDropdown className="mt-2 float-right">
            <DropdownToggle caret className="mr-2" color="primary">
              Actions
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => window.open(`/resources/influencers/download-csv?${getUrlSearch().toString()}`, '_blank').focus()}>Download CSV</DropdownItem>
            </DropdownMenu>
          </UncontrolledButtonDropdown>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <InputGroup>
            <Input
              className="form-control-sm form-control ml-3"
              name="search"
              type="search"
              autoComplete="off"
              placeholder="Search names, emails, channel urls or usernames"
              value={search}
              onChange={p => setSearch(p.target.value)}
            />
            <InputGroupAddon addonType="append">
              <InputGroupText>
                <i
                  className="fa fa-search"
                  aria-hidden="true"
                  style={{ color: '#70bbfd', fontSize: 12 }}
                />
              </InputGroupText>
            </InputGroupAddon>
          </InputGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="programCountrySelect"
              isClearable
              value={programCountryOptions.filter(opt => selectedProgramCountries.includes(opt.value))}
              options={programCountryOptions}
              isDisabled={loadingProgramCountryOptions}
              isLoading={loadingProgramCountryOptions}
              onChange={(data) => { dispatch(updateCreatorFilterItemUpdate('programCountryFilter', data)); }}
              placeholder="Program Countries"
              style={{ maxHeight: '120px', height: '31px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                spacing: {
                  ...theme.spacing,
                  controlHeight: 30,
                  baseUnit: 2,
                }
              })}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Select
              isMulti
              name="countrySelect"
              isClearable
              value={countryOpt.filter(opt => selectedCountries.includes(opt.value))}
              options={countryOpt}
              onChange={(data) => { dispatch(updateCreatorFilterItemUpdate('countryFilter', data)); }}
              placeholder="Countries"
              style={{ maxHeight: '120px', height: '31px' }}
              styles={colourStyles}
              theme={theme => ({
                ...theme,
                borderRadius: 0,
                spacing: {
                  ...theme.spacing,
                  controlHeight: 30,
                  baseUnit: 2,
                }
              })}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  );
});

Table.propTypes = {
  dispatch: PropTypes.func.isRequired,
  filters: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.objectOf(PropTypes.any).isRequired,
  }).isRequired,
};
export default connect(state => ({
  filters: state.creators.filters.creators,
}))(Table);
